const LOG_IN = '/'
const SIGN_UP = '/signup'
const ACCOUNT = '/account'
const PASSWORD_RESET = '/password-reset'
const DASHBOARD = '/dashboard'
const ADMIN = '/admin'

export { LOG_IN, SIGN_UP, ACCOUNT, PASSWORD_RESET, DASHBOARD, ADMIN }
